import { PropsWithChildren } from "react";
import SocialProofPanel from "./social-proof-panel";
import styles from "./claimable-authenticator-v2.module.scss";

const AuthLayout = ({ children }: PropsWithChildren) => {
  return (
    <div className={styles.authLayout}>
      <div className={styles.authLayoutContent}>
        <div className={styles.authLayoutInner}>
          <div className={styles.formContainer}>{children}</div>

          <div className={styles.socialProofWrapper}>
            <SocialProofPanel />
          </div>
        </div>
      </div>

      <div className={styles.authLayoutFooter}>
        <span
          className={styles.copyright}
        >{`© ${new Date().getFullYear()} All rights reserved.`}</span>
      </div>
    </div>
  );
};

export default AuthLayout;
